import { Linkable } from '@/components/blocks/Linkable';
import { productSkuSx, typographySx } from '@/components/blocks/PLPProductCard/styles/productSku';
import { ProductType } from '@/data/types/Product';
import { getHref_Product } from '@/utils/getHref_Product';
import { Typography } from '@mui/material';
import { memo } from 'react';

export const ProductSku = memo(
	({
		product,
		productHref,
		onClick,
	}: {
		productHref: ReturnType<typeof getHref_Product>;
		product: ProductType;
		onClick?: () => void;
	}) => (
		<Linkable
			sx={productSkuSx}
			href={productHref}
			color="textPrimary"
			onClick={onClick}
			className="product-sku"
		>
			<Typography sx={typographySx} variant="body1">{`SKU ${product.partNumber}`}</Typography>
		</Linkable>
	)
);
